export const OPEN_CAMPAIGN_SERVICE_EDITOR = 'OPEN_CAMPAIGN_SERVICE_EDITOR';
export type OPEN_CAMPAIGN_SERVICE_EDITOR = typeof OPEN_CAMPAIGN_SERVICE_EDITOR;

export interface OpenCampaignServiceEditor {
    type: OPEN_CAMPAIGN_SERVICE_EDITOR;
    editorId: string;
}

export function openCampaignServiceEditorAction(editorId: string): OpenCampaignServiceEditor {
    return {
        type: OPEN_CAMPAIGN_SERVICE_EDITOR,
        editorId
    };
}
